module.exports = __webpack_public_path__ + "img/myuse_caps.806efc2.png";